module.exports = __webpack_public_path__ + "media/dashboard/assets/images/priority_icons/none-f59961fadfbca49bc7388a3c54040916.svg";